import { createApp } from 'vue'
import store from './store'
import BasePage from './components/base/BasePage'
import Popper from "vue3-popper";
import ApolloClient from './graphql'
import { createApolloProvider } from '@vue/apollo-option'
import vClickOutside from "click-outside-vue3"
import NewsChess from "@/components/news/NewsChess.vue";
import SeeNewsChess from "@/components/news/SeeNewsChess.vue";
import LandingChess from "@/components/news/LandingChess.vue";
import TournamentChess from "@/components/news/TournamentChess.vue";
import TournamentRankedChess from "@/components/news/TournamentRankedChess.vue";
import MyTournamentArchivedChess from "@/components/news/MyTournamentArchivedChess.vue";
import MyTournamentChess from "@/components/news/MyTournamentChess.vue";
import CreateArticle from "@/components/news/CreateArticle.vue";
import SeeArticleChess from "@/components/news/SeeArticleChess.vue";
import InscriptionTournamentChess from "@/components/news/InscriptionTournamentChess.vue";
import ArticlesChess from "@/components/news/ArticlesChess.vue";
import LoginChess from "@/components/news/LoginChess.vue";
import PasswordChess from "@/components/news/PasswordChess.vue";
import SeeInscriptionTournament from "@/components/news/SeeInscriptionTournament.vue";
import SeeTournamentResult from "@/components/news/SeeTournamentResult.vue";
import LoadPlayers from "@/components/news/LoadPlayers.vue";
import PlayersChess from "@/components/news/PlayersChess.vue";
import CreatePlayersChess from "@/components/news/CreatePlayersChess.vue";
import SeePlayerChess from "@/components/news/SeePlayerChess.vue";
import SeeRuleChess from "@/components/news/SeeRuleChess.vue";
import CreateRule from "@/components/news/CreateRule.vue";
import ClubChess from "@/components/news/ClubChess.vue";
import RulesChess from "@/components/news/RulesChess.vue";
import SeeChangeClub from "@/components/news/SeeChangeClub.vue";
import SeeRankingPlayers from "@/components/news/SeeRankingPlayers.vue";
import SeeInscriptionClub from "@/components/news/SeeInscriptionClub.vue";
import SeeTournamentPlayerChess from "@/components/news/SeeTournamentPlayerChess.vue";
import SeeAdminClub from "@/components/news/SeeAdminClub.vue";
import SeeArbitrers from "@/components/news/SeeArbitrers.vue";
import SeeTrainers from "@/components/news/SeeTrainers.vue";
import SeeOrganizator from "@/components/news/SeeOrganizator.vue";
import SeeAdmins from "@/components/news/SeeAdmins.vue";
import SeeAccess from "@/components/news/SeeAccess.vue";
import SeePeriodPlayerChess from "@/components/news/SeePeriodPlayerChess.vue";
import CKEditor from '@ckeditor/ckeditor5-vue';
import { VueReCaptcha } from 'vue-recaptcha-v3'

const apolloProvider = createApolloProvider({
  defaultClient: ApolloClient,
})
// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
const vuetify = createVuetify({
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#3D6662',
          secondary: '#FFCDD2'
        }
      },
    },
  },
  components,
  directives,
})

import './index.css'
import 'flowbite';

// Creamos una instancia de la aplicación Vue
const app = createApp({
  // Elemento html donde se va ha renderizar el contenido
  el: '#app',
  // Activamos el componente dentro de la app
  components : {
    BasePage,
    NewsChess,
    LandingChess,
    TournamentChess,
    SeeNewsChess,
    CreateArticle,
    SeeArticleChess,
    LoginChess,
    ArticlesChess,
    MyTournamentChess,
    InscriptionTournamentChess,
    SeeInscriptionTournament,
    SeeTournamentResult,
    LoadPlayers,
    PlayersChess,
    CreatePlayersChess,
    PasswordChess,
    SeePlayerChess,
    SeeRuleChess,
    CreateRule,
    RulesChess,
    ClubChess,
    SeeInscriptionClub,
    TournamentRankedChess,
    MyTournamentArchivedChess,
    SeeChangeClub,
    SeeTournamentPlayerChess,
    SeePeriodPlayerChess,
    SeeRankingPlayers,
    SeeAdminClub,
    SeeArbitrers,
    SeeAccess,
    SeeTrainers,
    SeeOrganizator,
    SeeAdmins
  },
  // Creamos variable msg reactiva con ref
  data () {
    return {
      msg: 'Componente de VueJsasdasdadS 3'
    }
  },
})
app.component("PopperChess", Popper);
app.use(store)
app.use(apolloProvider)
app.use(vClickOutside)
app.use(vuetify)
app.use(CKEditor)
app.use(VueReCaptcha, { siteKey: '6LcJXYQnAAAAAAHNjtpgkQ8KY0deI-z70t9fwPpZ' })
// Montamos la app en el div #app de nuestra plantilla index.html.
app.mount('#app')



